import { Check, MessageCircle } from "lucide-react";
import { Reveal, SectionBadge } from "./Shared";
import { CLEANSES, IMAGES, waLink } from "../data";

export default function Cleanses() {
  return (
    <section id="cleanses" className="bg-bone py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <Reveal>
          <SectionBadge>02 — Juice Cleanses</SectionBadge>
        </Reveal>
        <div className="mt-8 flex flex-wrap items-end justify-between gap-8">
          <Reveal delay={0.1}>
            <h2 className="max-w-2xl font-serif text-5xl font-medium leading-[0.95] tracking-tighter text-ink md:text-7xl">
              Give your body <span className="italic text-leaf">a break</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-base font-light leading-relaxed text-leaf/80">
              Flood your system with nutrients from fresh, natural juices. Every
              cleanse is pressed to order and numbered in drinking order.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {CLEANSES.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.12} className={c.span}>
              <article
                data-testid={`cleanse-card-${c.id}`}
                className={`flex h-full flex-col gap-8 rounded-[32px] border p-8 md:p-12 ${
                  c.dark
                    ? "border-leaf bg-leaf text-cream lg:flex-row lg:items-center"
                    : "border-leaf/15 bg-cream text-ink"
                }`}
              >
                <div className="flex-1">
                  <div className="flex items-center gap-4">
                    <p className={`font-cursive text-2xl ${c.dark ? "text-sun" : "text-melon"}`}>{c.tagline}</p>
                    {c.badge && (
                      <span className="rounded-full bg-sun px-4 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-leaf">
                        {c.badge}
                      </span>
                    )}
                  </div>
                  <h3 className="mt-3 font-serif text-4xl font-medium tracking-tight md:text-5xl">{c.name}</h3>
                  <p className="mt-4 font-serif text-6xl font-medium tracking-tighter md:text-7xl">
                    <span className="align-top text-3xl">$</span>
                    {c.price}
                  </p>

                  <ul className="mt-6 space-y-2.5">
                    {c.features.map((f) => (
                      <li key={f} className="flex items-center gap-3 text-sm font-light">
                        <Check className={`h-4 w-4 shrink-0 ${c.dark ? "text-sun" : "text-melon"}`} />
                        {f}
                      </li>
                    ))}
                  </ul>

                  <div className={`mt-6 border-t pt-5 ${c.dark ? "border-cream/20" : "border-leaf/15"}`}>
                    <p className={`text-[10px] font-medium uppercase tracking-[0.25em] ${c.dark ? "text-cream/60" : "text-leaf/50"}`}>
                      Includes
                    </p>
                    <p className={`mt-2 text-sm font-light ${c.dark ? "text-cream/85" : "text-leaf/80"}`}>
                      {c.includes.join("  •  ")}
                    </p>
                  </div>

                  <a
                    href={waLink(`Hi Main Squeeze! I'd like to order the ${c.name} cleanse.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`cleanse-reserve-${c.id}`}
                    className={`mt-8 inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-medium transition-[background-color,color,transform] duration-300 hover:scale-95 ${
                      c.dark
                        ? "bg-cream text-leaf hover:bg-sun"
                        : "bg-leaf text-cream hover:bg-melon"
                    }`}
                  >
                    <MessageCircle className="h-4 w-4" />
                    Order on WhatsApp
                  </a>
                </div>

                {c.dark && (
                  <div className="w-full shrink-0 overflow-hidden rounded-t-[999px] rounded-b-[24px] lg:w-72">
                    <img
                      src={IMAGES.bottles}
                      alt="Cold-pressed juice bottles"
                      className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
                    />
                  </div>
                )}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
